<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="headers"
        :items="ei_items"
        class="elevation-1"
        :loading="eiLoading"
        loading-text="Загружаю данные"
        item-key="OKEI_ID"
        :search="eiSearch"
        locale="ru-RU"
        @dblclick:row="setValue"
        dense
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              v-model="eiSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('onCloseWindow', true)" v-if="mode == 'compact'">
              <v-icon>mdi-window-close</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'refOKEITable',
  props: ['value', 'mode'],
  data () {
    return {
      ei_headers: [
        { text: 'Наименование', value: 'OK_NAME', mode: ['full', 'compact'], class: 'blue-grey darken-1 font-weight-bold text-subtitle-2 white--text' },
        { text: 'Нац.обозначение', value: 'OK_COND_NAT_NAME', mode: ['full', 'compact'], class: 'blue-grey darken-1 font-weight-bold text-subtitle-2 white--text' },
        { text: 'Инт.обозначение', value: 'OK_COND_INTER_NAME', mode: ['full'], class: 'blue-grey darken-1 font-weight-bold text-subtitle-2 white--text' },
        { text: 'Нац.код', value: 'OK_CODE_NAT_NAME', mode: ['full'], class: 'blue-grey darken-1 font-weight-bold text-subtitle-2 white--text' },
        { text: 'Инт.код', value: 'OK_CODE_INTER_NAME', mode: ['full'], class: 'blue-grey darken-1 font-weight-bold text-subtitle-2 white--text' }
      ],
      eiLoading: false,
      eiSearch: '',
      ei_items: []
    }
  },

  computed: {
    title: {
      get () {
        const mode = this.mode || 'full'
        return mode === 'full' ? 'Общероссийский классификатор единиц измерения' : 'ОКЕИ'
      }
    },
    headers: {
      get () {
        const mode = this.mode || 'full'
        return this.ei_headers.filter(item => item.mode.some(itm => itm === mode))
      }
    }
  },
  mounted: function () {
    console.log('refOKEITable mounted')
    if (this.ei_items.length === 0) {
      this.getEIList()
    }
  },
  methods: {
    setValue (evt, data) {
      console.log('Setting value ', data)
      this.$emit('input', data.item)
    },
    getEIList () {
      console.log('Getting EI List')
      const self = this
      this.eiLoading = true
      axios({
        url: '/api/org/references/getOKEIList.php',
        method: 'POST'
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.ei_items.splice(0, self.ei_items.length, ...resp.data.data)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка единиц измерения: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения единиц измерения: \n ${err}` })
        })
        .finally(
          this.eiLoading = false
        )
    }
  }
}

</script>
